/**
 * Block Icons — all addon SVG icons rendered as <img> with base64 data URI sources.
 * No external icon library dependency; each icon is a self-contained SVG image.
 */

const b64 = ( svg ) =>
    `data:image/svg+xml;base64,${ btoa( unescape( encodeURIComponent( svg ) ) ) }`;

const Img = ( { svg, alt = '' } ) => (
    <img src={ b64( svg ) } width="22" height="22" alt={ alt } style={ { display: 'block' } } />
);

/* ── Primary brand colour ─────────────────────────────────────────────────── */
const C = '#6c1bc3';

/* ── Container ───────────────────────────────────────────────────────────── */
export const ContainerIcon = () => (
    <Img alt="Container" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="18" rx="2"/>
  <path d="M3 9h18"/>
  <path d="M9 9v12"/>
</svg>`} />
);

/* ── Button ──────────────────────────────────────────────────────────────── */
export const ButtonIcon = () => (
    <Img alt="Button" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M5 3l14 9-7 1-4 7L5 3z"/>
</svg>`} />
);

/* ── Heading ─────────────────────────────────────────────────────────────── */
export const HeadingIcon = () => (
    <Img alt="Heading" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M4 6v12"/>
  <path d="M20 6v12"/>
  <path d="M4 12h16"/>
</svg>`} />
);

/* ── Spacer ──────────────────────────────────────────────────────────────── */
export const SpacerIcon = () => (
    <Img alt="Spacer" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M12 3v18"/>
  <path d="M8 7l4-4 4 4"/>
  <path d="M8 17l4 4 4-4"/>
  <path d="M5 12h3M16 12h3" stroke-dasharray="2 1.5"/>
</svg>`} />
);

/* ── Product (WooCommerce) ───────────────────────────────────────────────── */
export const ProductIcon = () => (
    <Img alt="Product" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
  <line x1="3" y1="6" x2="21" y2="6"/>
  <path d="M16 10a4 4 0 01-8 0"/>
</svg>`} />
);

/* ── Post Grid ───────────────────────────────────────────────────────────── */
export const PostGridIcon = () => (
    <Img alt="Post Grid" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="7" height="9" rx="1.5"/>
  <rect x="14" y="3" width="7" height="9" rx="1.5"/>
  <rect x="3" y="15" width="7" height="6" rx="1.5"/>
  <rect x="14" y="15" width="7" height="6" rx="1.5"/>
</svg>`} />
);

/* ── Advance Slider ──────────────────────────────────────────────────────── */
export const SliderIcon = () => (
    <Img alt="Advance Slider" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="2" y="4" width="20" height="13" rx="2"/>
  <path d="M9 10.5l3-2 3 2"/>
  <circle cx="9" cy="20" r="1.2" fill="${C}" stroke="none"/>
  <circle cx="12" cy="20" r="1.6" fill="${C}" stroke="none"/>
  <circle cx="15" cy="20" r="1.2" fill="${C}" stroke="none"/>
</svg>`} />
);

/* ── Flip Box ────────────────────────────────────────────────────────────── */
export const FlipBoxIcon = () => (
    <Img alt="Flip Box" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="2" y="4" width="9" height="16" rx="1.5"/>
  <rect x="13" y="4" width="9" height="16" rx="1.5" stroke-dasharray="3 2"/>
  <path d="M9 12h7"/>
  <path d="M13.5 9.5l3 2.5-3 2.5"/>
</svg>`} />
);

/* ── Advanced Image ──────────────────────────────────────────────────────── */
export const ImageIcon = () => (
    <Img alt="Advanced Image" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="18" rx="2"/>
  <circle cx="8.5" cy="8.5" r="1.5"/>
  <path d="M21 15l-5-5L5 21"/>
</svg>`} />
);

/* ── Video Player ────────────────────────────────────────────────────────── */
export const VideoIcon = () => (
    <Img alt="Video Player" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M23 7l-7 5 7 5V7z"/>
  <rect x="1" y="5" width="15" height="14" rx="2"/>
</svg>`} />
);

/* ── Lottie Animation ────────────────────────────────────────────────────── */
export const LottieIcon = () => (
    <Img alt="Lottie" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M18.5 5.5c-4.1 0-5.6 2.9-6.8 5.2l-.8 1.5c-1.3 2.5-2.3 4-4.7 4" stroke="${C}" stroke-width="1.6" stroke-linecap="round"/>
  <circle cx="6" cy="17" r="1.8" fill="${C}"/>
  <circle cx="19" cy="7" r="1.8" fill="${C}"/>
</svg>`} />
);

/* ── FAQ ─────────────────────────────────────────────────────────────────── */
export const FaqIcon = () => (
    <Img alt="FAQ" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  <path d="M9.1 9a3 3 0 015.8 1c0 2-3 3-3 3"/>
  <line x1="12" y1="17" x2="12.01" y2="17"/>
</svg>`} />
);

/* ── Table of Contents ───────────────────────────────────────────────────── */
export const TableOfContentsIcon = () => (
    <Img alt="Table of Contents" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round">
  <path d="M4 6h16"/>
  <path d="M4 10h12"/>
  <path d="M4 14h16"/>
  <path d="M4 18h9"/>
</svg>`} />
);

/* ── Icon Block ──────────────────────────────────────────────────────────── */
export const IconBlockIcon = () => (
    <Img alt="Icon" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
</svg>`} />
);

/* ── Advance Timeline ────────────────────────────────────────────────────── */
export const TimelineIcon = () => (
    <Img alt="Advance Timeline" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round">
  <line x1="9" y1="4" x2="9" y2="20"/>
  <circle cx="9" cy="6.5" r="2" fill="${C}" stroke="none"/>
  <circle cx="9" cy="12" r="2" fill="${C}" stroke="none"/>
  <circle cx="9" cy="17.5" r="2" fill="${C}" stroke="none"/>
  <path d="M12 6.5h7"/>
  <path d="M12 12h7"/>
  <path d="M12 17.5h7"/>
</svg>`} />
);

/* ── Mega Menu ───────────────────────────────────────────────────────────── */
export const MegaMenuIcon = () => (
    <Img alt="Mega Menu" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M3 6h18M3 10h18"/>
  <rect x="3" y="13" width="18" height="8" rx="1.5" stroke-dasharray="3 2"/>
  <path d="M6 17h3M13 17h3"/>
</svg>`} />
);

/* ── Advance Query Loop ──────────────────────────────────────────────────── */
export const QueryLoopIcon = () => (
    <Img alt="Query Loop" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <path d="M21 2v5h-5"/>
  <path d="M3 12a9 9 0 0114.6-7L21 7"/>
  <path d="M3 22v-5h5"/>
  <path d="M21 12a9 9 0 01-14.6 7L3 17"/>
</svg>`} />
);

/* ── Image Hotspot ───────────────────────────────────────────────────────── */
export const ImageHotspotIcon = () => (
    <Img alt="Image Hotspot" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="2" y="4" width="20" height="14" rx="2"/>
  <circle cx="15" cy="9" r="2.5"/>
  <path d="M15 11.5v4"/>
  <path d="M13.5 13.5h3"/>
</svg>`} />
);

/* ── Blurb ───────────────────────────────────────────────────────────────── */
export const BlurbIcon = () => (
    <Img alt="Blurb" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="18" rx="2"/>
  <circle cx="12" cy="8.5" r="2.5"/>
  <path d="M8 15h8"/>
  <path d="M9.5 19h5"/>
</svg>`} />
);

/* ── Unfold ──────────────────────────────────────────────────────────────── */
export const UnfoldIcon = () => (
    <Img alt="Unfold" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="5.5" rx="1.5"/>
  <rect x="3" y="10.5" width="18" height="5.5" rx="1.5" stroke-dasharray="3 2"/>
  <rect x="3" y="18" width="18" height="3" rx="1.5" stroke-dasharray="3 2"/>
  <path d="M9.5 21.5l2.5 2 2.5-2" stroke-dasharray="none"/>
</svg>`} />
);

/* ── Post Pagination ─────────────────────────────────────────────────────── */
export const PostPaginationIcon = () => (
    <Img alt="Post Pagination" svg={`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${C}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <rect x="5" y="9" width="6" height="6" rx="1" fill="#f3ecff"/>
  <rect x="13" y="9" width="6" height="6" rx="1"/>
  <path d="M3 12h1M20 12h1"/>
  <path d="M4 12l-2 0M22 12l-2 0"/>
  <path d="M2.5 10l1.5 2-1.5 2"/>
  <path d="M21.5 10l-1.5 2 1.5 2"/>
</svg>`} />
);

/* ── NeedHelp ─────────────────────────────────────────────────────── */
export const NeedHelpIcon = () => (
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-life-buoy w-5 h-5 text-blue-500" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m4.93 4.93 4.24 4.24"></path><path d="m14.83 9.17 4.24-4.24"></path><path d="m14.83 14.83 4.24 4.24"></path><path d="m9.17 14.83-4.24 4.24"></path><circle cx="12" cy="12" r="4"></circle></svg>  
);

/* ── Documentation ─────────────────────────────────────────────────────── */
export const DocumentationIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-5 h-5 text-brand-600" aria-hidden="true"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path><path d="M14 2v5a1 1 0 0 0 1 1h5"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
          );

          /* ── StarSolidIcon ─────────────────────────────────────────────────────── */
export const StarSolidIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star text-yellow-500 fill-current" aria-hidden="true"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>          );
